<template>
    <div class="audit-detail" v-loading="pageLoading">
        <!-- 顶部活动信息 -->
        <div class="title">
            <el-alert type="warning" effect="light" :closable="false">
                <div slot="title">
                    当前活动：{{ detailData && detailData.activityTitle || '-' }}（活动ID：{{ activityIdText }}）
                </div>
            </el-alert>
        </div>

        <!-- 创建审核：活动全量信息只读展示 -->
        <template v-if="isCreateAudit && activity">
            <div class="part-title">基本信息</div>
            <el-card>
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">活动名称：</span>{{ activity.title || '-' }}</el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">分享名称：</span>{{ activity.articleTitle || '-' }}</el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">展示排行榜：</span>{{ activity.showRank == 1 ? '展示' : '不展示' }}</el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">跳转：</span>{{ jumpText }}</el-col>
                </el-row>
            </el-card>

            <div class="part-title">活动时间</div>
            <el-card>
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">展示时间：</span>{{ formatTime(activity.onTime) }} ~ {{ formatTime(activity.offTime) }}</el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">有效时间：</span>{{ formatTime(activity.startTime) }} ~ {{ formatTime(activity.endTime) }}</el-col>
                </el-row>
            </el-card>

            <div class="part-title">活动图片</div>
            <el-card>
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item">
                        <span class="label">活动列表图：</span>
                        <el-image v-if="activity.listImg" class="audit-img" :src="activity.listImg | coverImage(120, 120)"
                            :preview-src-list="[activity.listImg]" fit="cover"></el-image>
                        <span v-else>-</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item">
                        <span class="label">活动详情图：</span>
                        <el-image v-if="activity.poster" class="audit-img" :src="activity.poster | coverImage(120, 120)"
                            :preview-src-list="[activity.poster]" fit="cover"></el-image>
                        <span v-else>-</span>
                    </el-col>
                    <el-col :xs="24" :xl="16" class="info-item">
                        <span class="label">活动套图：</span>
                        <template v-if="imageList.length">
                            <el-image v-for="(img, i) in imageList" :key="i" class="audit-img" :src="img | coverImage(120, 120)"
                                :preview-src-list="imageList" fit="cover"></el-image>
                        </template>
                        <span v-else>-</span>
                    </el-col>
                </el-row>
            </el-card>

            <div class="part-title">门槛设置（活动玩法）</div>
            <el-card>
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">PV要求达到：</span>{{ activity.pv || '未设置' }}</el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">UV要求达到：</span>{{ activity.uv || '未设置' }}</el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">注册数要求达到：</span>{{ activity.registerNum || '未设置' }}</el-col>
                    <el-col :xs="24" :sm="12" :xl="8" class="info-item"><span class="label">订单要求达到：</span>{{ activity.orderNum || '未设置' }}</el-col>
                </el-row>
            </el-card>

            <div class="part-title">微博话术&关联演出</div>
            <el-card>
                <div class="info-item"><span class="label">微博话术：</span>{{ activity.blogShareTalk || '未填写（使用默认话术）' }}</div>
                <div class="MT10 info-item">
                    <span class="label">关联演出：</span>
                    <el-tag v-for="(item, i) in activityList" :key="i" size="small" class="MR10 MB10">{{ item.id }} {{ item.name }}</el-tag>
                    <span v-if="!activityList.length">-</span>
                </div>
            </el-card>

            <div class="part-title">其他信息</div>
            <el-card>
                <div class="info-item"><span class="label">活动规则：</span></div>
                <div class="rich-text" v-html="activity.rule || '-'"></div>
                <div class="MT20 info-item"><span class="label">活动详情：</span></div>
                <div class="rich-text" v-html="activity.detail || '-'"></div>
            </el-card>

            <div class="part-title">奖品设置</div>
            <el-card>
                <prize-table :prizes="prizes"></prize-table>
            </el-card>
        </template>

        
        <!-- 编辑审核：变动字段对比展示（左右对照，样式参照演出修改审核详情） -->
        <template v-if="!isCreateAudit">
            <div class="part-title">变动字段差异对比</div>
            
            <!-- 有变动字段：左侧原值/右侧新值对照展示 -->
            <el-row v-if="fieldRows.length" :gutter="20" type="flex" justify="space-between">
                <el-col :span="11">
                    <el-card class="compare-card">
                        <div class="MB10 compare-head">原值：</div>
                        <div v-for="row in fieldRows" :key="'source-' + row.key" class="info-item MT10">
                            <span class="label">{{ row.label }}：</span>
                            <!-- 图片字段渲染缩略图 -->
                            <template v-if="row.isImg && row.sourceImgs.length">
                                <el-image v-for="(img, i) in row.sourceImgs" :key="i" class="audit-img" :src="img | coverImage(60, 60)"
                                    :preview-src-list="row.sourceImgs" fit="cover"></el-image>
                            </template>
                            <!-- 富文本字段 -->
                            <div v-else-if="row.isRich" class="rich-text" v-html="row.sourceStr || '-'"></div>
                            <span v-else>{{ row.sourceStr || '-' }}</span>
                        </div>
                    </el-card>
                </el-col>
                <div class="separate-box"><div><i class="el-icon-arrow-right icon"></i></div></div>
                
                <el-col :span="11">
                    <el-card class="compare-card">
                        <div class="MB10 compare-head">新值：</div>
                        <div v-for="row in fieldRows" :key="'current-' + row.key" class="info-item MT10">
                            <span class="label">{{ row.label }}：</span>
                            <template v-if="row.isImg && row.currentImgs.length">
                                <el-image v-for="(img, i) in row.currentImgs" :key="i" class="audit-img" :src="img | coverImage(60, 60)"
                                    :preview-src-list="row.currentImgs" fit="cover"></el-image>
                            </template>
                            <div v-else-if="row.isRich" class="rich-text" v-html="row.currentStr || '-'"></div>
                            <span v-else>{{ row.currentStr || '-' }}</span>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            
            <el-card v-else><div>无变动字段</div></el-card>

            <!-- 新增奖品 -->
            <template v-if="addPrizes.length">
                <div class="part-title">新增奖品</div>
                <el-card>
                    <prize-table :prizes="addPrizes" tag-text="新增" tag-type="success"></prize-table>
                </el-card>
            </template>

            <!-- 删除奖品 -->
            <template v-if="deletePrizes.length">
                <div class="part-title">删除奖品</div>
                <el-card>
                    <prize-table :prizes="deletePrizes" tag-text="删除" tag-type="danger"></prize-table>
                </el-card>
            </template>

            <!-- 修改奖品对比 -->
            <template v-if="updatePrizeRows.length">
                <div class="part-title">修改奖品对比</div>
                <el-card>
                    <el-table v-for="(rows, i) in updatePrizeRows" :key="i" :data="rows" border size="small" stripe class="MB20">
                        <el-table-column prop="label" label="奖品字段" width="140"></el-table-column>
                        <el-table-column label="原值" min-width="200">
                            <template slot-scope="{row}">
                                <span :class="{ 'color-info': row.changed }">{{ row.sourceStr || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="新值" min-width="200">
                            <template slot-scope="{row}">
                                <span :class="{ 'color-danger': row.changed }">{{ row.currentStr || '-' }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </template>
        </template>

        <!-- 审核信息 -->
        <template v-if="detailData">
            <div class="part-title">审核信息</div>
            <el-card>
                
                <!-- 提交审核时间：优先 submitTime，缺失时回退 createTime（后端详情接口暂未返回 submitTime） -->
                <div class="info-item"><span class="label">提交审核时间：</span>{{ detailData.submitTime || detailData.createTime || '-' }}</div>
                <div class="MT10 info-item"><span class="label">审核状态：</span>{{ auditStatusText }}</div>
                <div class="MT10 info-item"><span class="label">审核时间：</span>{{ detailData.auditTime || '-' }}</div>
            </el-card>
        </template>

        <!-- 底部操作按钮 -->
        <div class="btn-box MT20">
            <el-button @click="goBack" size="medium">返 回</el-button>
            <template v-if="detailData && detailData.auditStatus == 0">
                <el-button type="success" @click="approve" size="medium"
                    v-if="$utils.have('/share/activity/audit/approve')">通 过</el-button>
                <el-button type="danger" @click="rejectDialogShow = true" size="medium"
                    v-if="$utils.have('/share/activity/audit/reject')">拒 绝</el-button>
            </template>
        </div>

        <!-- 拒绝审核弹窗：填写拒绝原因 -->
        <el-dialog title="拒绝审核" :visible.sync="rejectDialogShow" width="520px" :close-on-click-modal="false">
            <el-form :model="rejectForm" :rules="rejectRules" ref="rejectForm" label-position="top">
                <el-form-item label="拒绝原因:" prop="rejectReason">
                    <el-input type="textarea" v-model="rejectForm.rejectReason" placeholder="请输入拒绝原因"
                        maxlength="100" show-word-limit :rows="4"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="rejectDialogShow = false">取 消</el-button>
                <el-button type="danger" size="medium" :loading="btnLoading" @click="submitReject">确 认 拒 绝</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import PrizeTable from './components/prizeTable.vue';
// 变动字段中文映射（编辑审核 fieldUpdateMap）
const fieldLabelMap = {
    title: '活动名称',
    articleTitle: '分享名称',
    showRank: '展示排行榜',
    onTime: '展示开始时间',
    offTime: '展示结束时间',
    startTime: '有效开始时间',
    endTime: '有效结束时间',
    listImg: '活动列表图',
    poster: '活动详情图',
    images: '活动套图',
    musicUri: '背景音乐',
    pv: 'PV要求',
    uv: 'UV要求',
    registerNum: '注册数要求',
    orderNum: '订单要求',
    blogShareTalk: '微博话术',
    rule: '活动规则',
    detail: '活动详情',
    activityIds: '关联演出'
};
// 图片类字段（对比时渲染缩略图）
const imgFields = ['listImg', 'poster', 'images'];
// 富文本类字段（对比时渲染 html）
const richFields = ['rule', 'detail'];
// 奖品字段中文映射（修改奖品对比用）
const prizeFieldList = [
    { key: 'prizeItem', label: '奖项' },
    { key: 'prizeType', label: '奖品类型' },
    { key: 'prizeInfo', label: '奖品内容' },
    { key: 'autoSendReward', label: '自动发奖' },
    { key: 'rankRange', label: '自动发放排名' },
    { key: 'autoSendTime', label: '自动发放时间' },
    { key: 'awardDeadline', label: '信息收集截止时间' },
    { key: 'collectInfo', label: '信息收集' }
];
export default {
    name: 'ShareActivityAuditDetail',
    components: { PrizeTable },
    props: {
        // 审核记录 id（路由参数）
        auditId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            pageLoading: false,
            btnLoading: false,
            detailData: null,      // 审核记录详情
            activity: null,        // 创建审核：活动全量信息
            prizes: [],            // 创建审核：活动奖品
            fieldUpdateMap: null,  // 编辑审核：变动字段 {字段: {sourceStr, currentStr}}
            addPrizes: [],         // 编辑审核：新增奖品
            deletePrizes: [],      // 编辑审核：删除奖品
            updatePrizes: [],      // 编辑审核：修改奖品
            // 拒绝弹窗
            rejectDialogShow: false,
            rejectForm: { rejectReason: '' },
            rejectRules: {
                rejectReason: [{ required: true, message: '请填写拒绝原因' }]
            },
            redirect: this.$route.query.redirect || '/promotion/shareActivity/list'
        };
    },
    computed: {
        
        // 是否创建审核（1 创建审核 2 编辑审核）：优先以后端详情返回的 auditType 为准（URL query 可能与记录实际类型不符），详情未加载时回退 query
        isCreateAudit() {
            if (this.detailData && this.detailData.auditType !== undefined) {
                return this.detailData.auditType == 1;
            }
            return parseInt(this.$route.query.auditType || 1) == 1;
        },
        
        // 顶部活动ID：优先取审核记录上的活动ID字段（编辑审核场景 activity 为空），创建审核回退 activity.id；字段名以后端实际返回为准，联调时确认
        activityIdText() {
            return (this.detailData && (this.detailData.activityId || this.detailData.shareActivityId))
                || (this.activity && this.activity.id)
                || '-';
        },
        
        // 审核状态文案：详情接口暂未返回 auditStatusView，按 auditStatus 数字映射（0 待审核 1 已通过 2 已拒绝 3 已撤销）
        auditStatusText() {
            const map = { 0: '待审核', 1: '已通过', 2: '已拒绝', 3: '已撤销' };
            return (this.detailData && (this.detailData.auditStatusView || map[this.detailData.auditStatus])) || '-';
        },
        // 跳转文案
        jumpText() {
            const _activity = this.activity || {};
            const typeMap = { 1: '演出', 2: '周边', 3: '外部网页', 4: '不跳转' };
            const _type = typeMap[_activity.jumpType] || '不跳转';
            return _activity.jumpType == 4 || !_activity.jumpUrl ? _type : `${_type}（${_activity.jumpUrl}）`;
        },
        // 活动套图（逗号分隔转数组）
        imageList() {
            return this.activity && this.activity.images ? this.activity.images.split(',').filter(v => v) : [];
        },
        // 关联演出列表
        activityList() {
            return this.activity && this.activity.activities || [];
        },
        // 变动字段对比表格行
        fieldRows() {
            const _rows = [];
            if (!this.fieldUpdateMap) return _rows;
            // 跳转类型/地址合并为一行"跳转"，完整展示跳转到的内容（参照创建审核 jumpText 逻辑）
            if (this.fieldUpdateMap.jumpType || this.fieldUpdateMap.jumpUrl) {
                const _jumpType = this.fieldUpdateMap.jumpType || {};
                const _jumpUrl = this.fieldUpdateMap.jumpUrl || {};
                _rows.push({
                    key: 'jump',
                    label: '跳转',
                    sourceStr: this.formatJumpText(_jumpType.sourceStr, _jumpUrl.sourceStr),
                    currentStr: this.formatJumpText(_jumpType.currentStr, _jumpUrl.currentStr),
                    isImg: false,
                    isRich: false,
                    sourceImgs: [],
                    currentImgs: []
                });
            }
            Object.keys(this.fieldUpdateMap).forEach(key => {
                // 跳转类型/地址已合并展示，跳过
                if (key == 'jumpType' || key == 'jumpUrl') return;
                const _item = this.fieldUpdateMap[key] || {};
                let _sourceStr = _item.sourceStr;
                let _currentStr = _item.currentStr;
                // 展示排行榜转"是/否"
                if (key == 'showRank') {
                    if (_sourceStr !== undefined && _sourceStr !== '') _sourceStr = _sourceStr == 1 ? '是' : '否';
                    if (_currentStr !== undefined && _currentStr !== '') _currentStr = _currentStr == 1 ? '是' : '否';
                }
                _rows.push({
                    key,
                    label: fieldLabelMap[key] || key, // 未知字段兜底展示英文 key
                    sourceStr: _sourceStr,
                    currentStr: _currentStr,
                    isImg: imgFields.includes(key),
                    isRich: richFields.includes(key),
                    // 图片字段可能是逗号分隔多图
                    sourceImgs: _item.sourceStr ? String(_item.sourceStr).split(',').filter(v => v) : [],
                    currentImgs: _item.currentStr ? String(_item.currentStr).split(',').filter(v => v) : []
                });
            });
            return _rows;
        },
        // 修改奖品对比表格行（二维数组：每个修改的奖品一组行）
        updatePrizeRows() {
            const _rowsGroup = [];
            this.updatePrizes.forEach(item => {
                // 后端返回结构为 {before, after}
                const _source = item.before || {};
                const _current = item.after || {};
                const _rows = prizeFieldList.map(field => {
                    const _sourceStr = this.formatPrizeField(_source, field.key);
                    const _currentStr = this.formatPrizeField(_current, field.key);
                    return {
                        ...field,
                        sourceStr: _sourceStr,
                        currentStr: _currentStr,
                        changed: _sourceStr != _currentStr // 标记变动行
                    };
                });
                _rowsGroup.push(_rows);
            });
            return _rowsGroup;
        }
    },
    created() {
        this.getDetail();
    },
    methods: {
        // 获取审核详情
        getDetail() {
            this.pageLoading = true;
            this.$request({
                url: "/share/activity/audit/detail",
                method: "POST",
                params: { auditId: this.auditId }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.detailData = result;
                        this.activity = result.activity || null;
                        this.prizes = result.prizes || [];
                        this.fieldUpdateMap = result.fieldUpdateMap || null;
                        this.addPrizes = result.addPrizes || [];
                        this.deletePrizes = result.deletePrizes || [];
                        this.updatePrizes = result.updatePrizes || [];
                    } else {
                        this.$message.error(msg || "获取详情失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.pageLoading = false;
                });
        },
        // 时间格式化：兼容时间戳与已格式化字符串
        formatTime(val) {
            if (!val) return '-';
            // 纯数字视为时间戳（10 位为秒级需转毫秒，13 位为毫秒级直接使用）
            if (/^\d{10,13}$/.test(String(val))) {
                const _num = Number(val);
                return this.$utils.formatDate(String(val).length == 10 ? _num * 1000 : _num, 'yyyy-MM-dd HH:mm:ss');
            }
            return val;
        },
        // 跳转完整文案（变动字段对比用）：类型映射文字 + 跳转地址
        formatJumpText(type, url) {
            const _typeMap = { 1: '演出', 2: '周边', 3: '外部网页', 4: '不跳转' };
            // 类型兼容数字/字符串编号与后端已格式化文字
            const _type = _typeMap[type] || (type ? String(type) : '');
            // 类型缺失（如仅改了地址未改类型）时不能假定"不跳转"，仅展示地址
            if (!_type) return url || '-';
            return _type == '不跳转' || !url ? _type : `${_type}（${url}）`;
        },
        // 奖品字段取值与格式化（修改奖品对比用）
        formatPrizeField(prize, key) {
            if (!prize) return '';
            switch (key) {
                case 'prizeType':
                    return prize.prizeType == 1 ? '优惠券' : '自定义奖品';
                case 'autoSendReward':
                    return prize.autoSendReward == 1 ? '是' : '否';
                case 'rankRange':
                    return prize.autoSendReward == 1 ? `第${prize.autoSendStartRank || '-'}名 至 第${prize.autoSendEndRank || '-'}名` : '';
                case 'autoSendTime':
                    return prize.autoSendReward == 1 ? this.formatTime(prize.autoSendTime) : '';
                case 'awardDeadline':
                    return this.formatTime(prize.awardDeadline);
                case 'collectInfo':
                    // 审核详情接口字段为 collectInfo
                    return this.formatCollectInfos(prize.collectInfo);
                default:
                    return prize[key] != undefined && prize[key] !== '' ? String(prize[key]) : '';
            }
        },
        // 信息收集转文本描述
        formatCollectInfos(infos) {
            // 兼容 JSON 字符串形式（审核详情快照可能序列化存储），解析失败视为无信息
            if (typeof infos == 'string' && infos.trim()) {
                try {
                    infos = JSON.parse(infos);
                } catch (e) {
                    infos = null;
                }
            }
            if (!Array.isArray(infos) || !infos.length) return '无需收集信息';
            return infos.map(item => {
                if (item.question != undefined) {
                    return `问题：${item.question}`;
                }
                if (item.chooseItems != undefined) {
                    return `选项组：${item.chooseTitle || ''}（${(item.chooseItems || []).join('、')}）`;
                }
                return '';
            }).filter(v => v).join('；');
        },
        // 通过审核（二次确认）
        approve() {
            this.$confirm('是否确认通过该分享活动审核？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.btnLoading = true;
                this.$request({
                    url: "/share/activity/audit/approve",
                    method: "POST",
                    params: { auditId: this.auditId }
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.$message.success("审核通过");
                            this.getDetail(); // 刷新详情更新审核状态
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
            }).catch(() => { });
        },
        // 提交拒绝
        submitReject() {
            this.$refs.rejectForm.validate((valid) => {
                if (!valid) return false;
                this.btnLoading = true;
                this.$request({
                    url: "/share/activity/audit/reject",
                    method: "POST",
                    params: {
                        auditId: this.auditId,
                        rejectReason: this.rejectForm.rejectReason
                    }
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.$message.success("已拒绝");
                            this.rejectDialogShow = false;
                            this.getDetail(); // 刷新详情更新审核状态
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
            });
        },
        // 返回列表
        goBack() {
            this.$router.push({ path: this.redirect });
        }
    }
};
</script>
<style lang="scss" scoped>
/* 审核详情页样式 */
.audit-detail {
    .title {
        margin: -20px -20px 0 -20px;

        .el-alert {
            border-radius: 0;

            ::v-deep .el-alert__title {
                font-size: 14px;
            }
        }
    }

    /* 分区标题 */
    .part-title {
        padding: 20px 0 10px;
        font-weight: 600;
    }

    /* 信息展示项 */
    .info-item {
        line-height: 24px;
        word-break: break-all;

        .label {
            color: $--color-info;
        }
    }

    /* 富文本展示区 */
    .rich-text {
        padding: 10px;
        background: #fafafa;
        border: 1px solid #ebeef5;
        border-radius: 4px;

        ::v-deep img {
            max-width: 100%;
        }
    }

    /* 图片缩略图 */
    .audit-img {
        width: 60px;
        height: 60px;
        margin: 5px 5px 0 0;
        border-radius: 4px;
        vertical-align: middle;
    }

    /* 左右对比卡片（参照演出修改审核详情样式） */
    .compare-card {
        min-height: 100%;
    }

    .compare-head {
        color: $--color-info;
    }

    /* 左右对比中间箭头（参照演出修改审核样式） */
    .separate-box {
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        div {
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            background: #ccc;
        }

        .icon {
            font-size: 20px;
            color: #fff;
        }
    }

    .btn-box {
        padding-top: 20px;
    }
}
</style>
